import { Avatar } from "@helmr/ui";
import { useAppContext } from "../../app/permissions";
import { NAME_HIDDEN } from "../../lib/names";
import { useDirectory } from "./useDirectory";

/**
 * A colleague on a row: avatar and name. `name` is what the server sent (`ownerName`, `assigneeName`), null when the
 * role holds no name lever, and then the row reads "Staff member", never a fragment of the id. Yourself reads as your
 * own name, or "You" when `you` is set.
 */
export function StaffName({ id, name, you = false }: { id: string | null | undefined; name: string | null | undefined; you?: boolean }) {
  const ctx = useAppContext();
  const dir = useDirectory();
  if (!id) return null;
  const myId = ctx.me?.staff.id ?? null;
  const label = you && id === myId ? NAME_HIDDEN.you : dir.nameOf(id, "staff", name ?? null)!;
  return <><Avatar id={id} name={label} size="xs" />{label}</>;
}
